import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import AdminLayout from "layouts/Admin";
import AuthLayout from "layouts/Auth";
import { ROLES } from "variables/constants";
import { ForgetPassword } from "pages/ForgetPassword/ForgetPassword";
import { useAuth } from "context/AuthContext";
import LoadingScreen from "components/Common/LoadingScreen";
import Publisher from "layouts/Publisher";

function App() {
  const { role, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen />;

  // ✅ Helper to preserve query params
  const preserveQuery = (path) => `${path}${location.search}`;

  return (
    <Routes>
      {/* Admin */}
      <Route
        path="/admin/*"
        element={
          isAuthenticated ? (
            <AdminLayout />
          ) : (
            <Navigate to={preserveQuery("/auth/login")} replace />
          )
        }
      />

      {/* Publisher */}
      <Route
        path="/publisher/*"
        element={
          isAuthenticated ? (
            <Publisher />
          ) : (
            <Navigate to={preserveQuery("/auth/login")} replace />
          )
        }
      />

      {/* Auth */}
      <Route
        path="/auth/*"
        element={
          !isAuthenticated ? (
            <AuthLayout />
          ) : (
            <Navigate
              to={preserveQuery(
                role === ROLES.superAdmin || role === ROLES.admin
                  ? "/admin/dashboard"
                  : "/publisher/dashboard"
              )}
              replace
            />
          )
        }
      />

      {/* Forgot password (no redirect needed) */}
      <Route path="/auth/forgot-password" element={<ForgetPassword />} />

      {/* Catch-all */}
      <Route
        path="*"
        element={
          isAuthenticated ? (
            <Navigate
              to={preserveQuery(
                role === ROLES.superAdmin || role === ROLES.admin
                  ? "/admin/dashboard"
                  : "/publisher/dashboard"
              )}
              replace
            />
          ) : (
            <Navigate to={preserveQuery("/auth/login")} replace />
          )
        }
      />
    </Routes>
  );
}

export default App;
